module.exports = __webpack_public_path__ + "static/img/12.0f83d84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/12.png
// module id = IlSP
// module chunks = 0